var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappDelete = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_delete_svg__a)",
  stroke: "#3A434A",
  strokeWidth: 1.5,
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.072 5.35h17.857"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.415 5.35H3.58c-.208 3.747-.204 7.464.354 11.187A2.808 2.808 0 0 0 6.71 18.93h6.574c1.39 0 2.57-1.017 2.777-2.392.558-3.723.561-7.44.354-11.187ZM6.431 5.35v-.713a3.566 3.566 0 1 1 7.132 0v.713M7.857 9.17v5.91M12.136 9.17v5.91",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_delete_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgWebappDelete;